import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation, useNavigate } from 'react-router-dom';
import one from '../../assets/icons/e-learning/one.svg'
import two from '../../assets/icons/e-learning/two.svg'
import add from '../../assets/icons/e-learning/add_back.svg'
import icon_delete from '../../assets/icons/e-learning/delete.svg'
import styles from './elearning.module.css'
import CloseIcon from '@mui/icons-material/Close';
import * as api from '../services/api'
import Loader from '../../components/Loader'

function EditCourse() {
    const navigate = useNavigate()
    const location = useLocation()
    const [loading, setLoading] = useState(false)

    const imgRef = useRef(null);
    const linkRef = useRef(null);
    // const fileRef = useRef(null);
    const fileRef = useRef([]);

    const [itemList, setItemList] = useState(null)

    const [data, setData] = useState({
        name: '',
        image: null,
        detail: '',
        keyword: '',
        hour: '',
        form_type: ''
    })

    const [course, setCourse] = useState([{
        title: '',
        attactment_files: [
            {
                url: '',
                file_type: "document"
            },
            {
                url: '',
                file_type: "video"
            }
        ]
    }])

    const [quizPre, setQuizPre] = useState([{
        question_number: "",
        question_type: "ratio",
        question_name: "",
        question_answer: [
            {
                name: "",
                value: "0"
            }
        ]
    }])

    const [quizPost, setQuizPost] = useState([{
        question_number: "",
        question_type: "ratio",
        question_name: "",
        question_answer: [
            {
                name: "",
                value: "0"
            }
        ]
    }])

    const [choice, setChoice] = useState([])

    if (!location.state) {
        location.state = { button: "1" };
    }

    useEffect(() => {
        console.log(location.state.item)
        let data = location.state.item
        setItemList(data)
        setData({
            ...data,
            name: data?.['e_learning_name'],
            image: data?.['e_learning_image'],
            detail: data?.['e_learning_detail'],
            keyword: data?.['e_learning_keyword'],
            hour: data?.['e_learning_hour'],
            form_type: data?.['test_form_type']
        })
        { data?.['post_test_form'] === null ? setQuizPost([]) : setQuizPost(data?.['post_test_form']) }
        { data?.['pre_test_form'] === null ? setQuizPre([]) : setQuizPre(data?.['pre_test_form']) }
        setCourse(data['properties'])

        data?.['properties'].map(i => {
            choice.push({ type: 'link' })
            setChoice([...choice])
        })
    }, [])

    const handleButton = (number) => {
        navigate('/editCourse', { state: { button: number } });
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value })
    }

    const handleButtonClick = () => {
        imgRef.current.click();
    }
    const handleFileChange = async (event) => {
        const file = event.target.files && event.target.files[0];
        if (!file) return;

        // let formData = new FormData()
        // formData.append('file', file)

        // setLoading(true)
        // let res = await api.uploadFile2('course', formData)
        // setLoading(false)
        // if (res) {
        //     if (res['data']['code'] === 200) {
        //         console.log(res['data']['data']['url'])
        //         setData({ ...data, 'image': res['data']['data']['url'] })
        //     } else {
        //         //alert(res['data']['message'])
        //     }
        // } else {
        //     alert('ไม่ตอบสนอง')
        // }
        let formData = new FormData()
        formData.append('file', file)
        formData.append('file_path', `/e_learning`)
        formData.append('file_source', 'e_learning')
        formData.append('file_name', file.name)

        setLoading(true)
        let res = await api.uploadFileImage('e_learning', formData)
        setLoading(false)
        if (!res) return alert('ไม่ตอบสนอง')

        const code = res['code']
        if (code === 200) {
            setData({ ...data, 'image': res['data']['file_api_url'] })
        } else if (code === 403) {
            alert('รูปประกอบ E-Learning รองรับไฟล์เฉพาะ .jpeg, .jpg, .png เท่านั้น')
        } else {
            console.log('error', res)
            alert('ไม่ตอบสนอง')
        }
    }

    const handleButtonClickVideo = () => {
        linkRef.current.click();
    }
    const handleFileChangeVideo = async (e, idx) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;

        let formData = new FormData()
        formData.append('file', file)

        setLoading(true)
        let res = await api.uploadFile2('course', formData)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                // console.log(res['data']['data']['url'])
                let dataUrl = res['data']['data']['url']
                let newCourse = [...course];
                newCourse[idx].attactment_files[1].url = dataUrl;
                setCourse(newCourse);
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const handleButtonClickDoc = (index) => {
        fileRef.current[index].click();
    }
    const handleFileChangeDoc = async (e, idx) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;

        let formData = new FormData()
        formData.append('file', file)

        setLoading(true)
        let res = await api.uploadFile2('course', formData)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                // console.log(res['data']['data']['url'])
                let dataUrl = res['data']['data']['url']
                let newCourse = [...course];
                newCourse[idx].attactment_files[0].url = dataUrl;
                setCourse(newCourse);
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const removeValueCourse = (i) => {
        course.splice(i, 1)
        setCourse([...course])

        choice.splice(i, 1)
        setChoice([...choice])
        console.log(choice)
    }
    const addValueCourse = () => {
        course.push({
            title: '',
            attactment_files: [
                {
                    url: '',
                    file_type: "document"
                },
                {
                    url: '',
                    file_type: "video"
                }
            ]
        })
        setCourse([...course])

        choice.push({
            type: 'link'
        })
        setChoice([...choice])
    }
    const handleChangeCourse = (e, idx) => {
        course[idx] = {
            title: e.target.value,
            attactment_files: course[idx]['attactment_files']
        }
        setCourse([...course])
    }
    const handleChangeRadio = (e, idx) => {
        let newCourse = [...course];
        newCourse[idx].attactment_files[1].url = '';
        setCourse(newCourse);

        choice[idx] = {
            type: e.target.value
        }
        setChoice([...choice])
    }
    const handleChangeCourseVideo = (e, idx) => {
        let newCourse = [...course];
        newCourse[idx].attactment_files[1].url = e.target.value;
        setCourse(newCourse);
    }

    const removeValueQuizPre = (i) => {
        quizPre.splice(i, 1)
        setQuizPre([...quizPre])
        console.log(quizPre)
    }
    const addValueQuizPre = () => {
        quizPre.push({
            question_number: "",
            question_type: "ratio",
            question_name: "",
            question_answer: [
                {
                    name: "",
                    value: "0"
                }
            ]
        })
        setQuizPre([...quizPre])
    }
    const handleChangeNameQuiz = (e, index) => {
        quizPre[index] = {
            question_number: index + 1,
            question_type: "ratio",
            question_name: e.target.value,
            question_answer: quizPre[index]['question_answer']
        }
        setQuizPre([...quizPre])
    }
    const handleChangeValueChoicePre = (e, index, idx) => {
        let value = e.target.checked ? '1' : '0'
        // console.log(value)
        quizPre[index]['question_answer'][idx] = {
            name: quizPre[index]['question_answer'][idx]['name'],
            value: value
        }
        setQuizPre([...quizPre])
    }

    const removeChoicePre = (index, i) => {
        quizPre[index]['question_answer'].splice(i, 1)
        setQuizPre([...quizPre])
    }
    const addChoicePre = (index) => {
        quizPre[index]['question_answer'].push({
            name: "",
            value: "0"
        })
        setQuizPre([...quizPre])
    }
    const handleChangeNameChoice = (e, index, idx) => {
        quizPre[index]['question_answer'][idx] = {
            name: e.target.value,
            value: quizPre[index]['question_answer'][idx]['value']
        }
        setQuizPre([...quizPre])
    }

    const removeValueQuizPost = (i) => {
        quizPost.splice(i, 1)
        setQuizPost([...quizPost])
    }
    const addValueQuizPost = () => {
        quizPost.push({
            question_number: "",
            question_type: "ratio",
            question_name: "",
            question_answer: [
                {
                    name: "",
                    value: "0"
                }
            ]
        })
        setQuizPost([...quizPost])
    }
    const handleChangeNameQuizPost = (e, index) => {
        quizPost[index] = {
            question_number: index + 1,
            question_type: "ratio",
            question_name: e.target.value,
            question_answer: quizPost[index]['question_answer']
        }
        setQuizPost([...quizPost])
    }
    const handleChangeValueChoicePost = (e, index, idx) => {
        let value = e.target.checked ? '1' : '0'
        quizPost[index]['question_answer'][idx] = {
            name: quizPost[index]['question_answer'][idx]['name'],
            value: value
        }
        setQuizPost([...quizPost])

    }

    const removeChoicePost = (index, i) => {
        quizPost[index]['question_answer'].splice(i, 1)
        setQuizPost([...quizPost])
    }
    const addChoicePost = (index) => {
        quizPost[index]['question_answer'].push({
            name: "",
            value: "0"
        })
        setQuizPost([...quizPost])
    }
    const handleChangeNameChoicePost = (e, index, idx) => {
        quizPost[index]['question_answer'][idx] = {
            name: e.target.value,
            value: quizPost[index]['question_answer'][idx]['value']
        }
        setQuizPost([...quizPost])
    }

    const addSequentialIndex = (array, start = 1) => {
        return array.map((item, i) => ({
            ...item,
            question_number: i + start,
        }));
    }

    const clickSaveNewCourse = () => {
        console.log(data['form_type'])
        if (data['form_type'] === 'มีแบบประเมินทั้งก่อนและท้ายบทเรียน') {
            let list = {
                "e_learning_code": itemList['e_learning_code'],
                "e_learning_name": data['name'],
                "remark": itemList['remark'],
                "doc_status": itemList['doc_status'],
                "created_date": itemList['created_date'],
                "created_user": itemList['created_user'],
                "updated_date": null,
                "updated_user": null,
                "e_learning_group_code": itemList['e_learning_group_code'],
                "e_learning_detail": data['detail'],
                "e_learning_image": data['image'],
                "e_learning_keyword": data['keyword'],
                "e_learning_hour": data['hour'],
                "properties": course,
                "test_form_type": data['form_type'],
                "pre_test_form": addSequentialIndex(quizPre),
                "post_test_form": addSequentialIndex(quizPost)
            }
            console.log('มีแบบประเมินท้ายบทเรียนอย่างเดียว', list)
            updateCourse(list)
        } else if (data['form_type'] === 'มีแบบประเมินก่อนบทเรียนอย่างเดียว') {
            let list = {
                "e_learning_code": itemList['e_learning_code'],
                "e_learning_name": data['name'],
                "remark": itemList['remark'],
                "doc_status": itemList['doc_status'],
                "created_date": itemList['created_date'],
                "created_user": itemList['created_user'],
                "updated_date": null,
                "updated_user": null,
                "e_learning_group_code": itemList['e_learning_group_code'],
                "e_learning_detail": data['detail'],
                "e_learning_image": data['image'],
                "e_learning_keyword": data['keyword'],
                "e_learning_hour": data['hour'],
                "properties": course,
                "test_form_type": data['form_type'],
                "pre_test_form": addSequentialIndex(quizPre),
                "post_test_form": []
            }
            console.log('ก่อนบทเรียนอย่างเดียว', list)
            updateCourse(list)
        } else {
            let list = {
                "e_learning_code": itemList['e_learning_code'],
                "e_learning_name": data['name'],
                "remark": itemList['remark'],
                "doc_status": itemList['doc_status'],
                "created_date": itemList['created_date'],
                "created_user": itemList['created_user'],
                "updated_date": null,
                "updated_user": null,
                "e_learning_group_code": itemList['e_learning_group_code'],
                "e_learning_detail": data['detail'],
                "e_learning_image": data['image'],
                "e_learning_keyword": data['keyword'],
                "e_learning_hour": data['hour'],
                "properties": course,
                "test_form_type": data['form_type'],
                "pre_test_form": [],
                "post_test_form": addSequentialIndex(quizPost)
            }
            console.log('หลังบทเรียนอย่างเดียว', list)
            updateCourse(list)
        }
    }

    const updateCourse = async (data) => {
        setLoading(true)
        let res = await api.updateCourse(data)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                alert('บันทึกสำเร็จ')
                navigate('/allCategories')
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/allCategories') }}
                    >กลับไป จัดการห้องเรียนออนไลน์</Box>
                </Box>

                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>แก้ไขหลักสูตร</Box>

                <Box sx={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                    {location.state.button === "1" ? (
                        <img className={styles.number} src={one} />
                    ) : null}
                    {location.state.button === "2" ? (
                        <img className={styles.number} src={two} />
                    ) : null}
                </Box>

                {location.state.button === "1" ? (
                    <>
                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            padding: '20px',
                            display: 'grid',
                            gridGap: '10px'
                        }}>
                            <Box>
                                <Box sx={{ fontWeight: 500 }}>ชื่อหลักสูตร</Box>
                                <TextField
                                    size='small'
                                    fullWidth
                                    placeholder='ชื่อหลักสูตร'
                                    name='name'
                                    value={data['name']}
                                    onChange={handleChange}
                                />
                            </Box>
                            <Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '5px', fontWeight: 500 }}>
                                    รูปภาพประกอบ
                                    <img
                                        style={{ width: '25px', cursor: 'pointer' }}
                                        src={add}
                                        onClick={handleButtonClick}
                                    />
                                </Box>
                                <Box sx={{
                                    border: '1px solid #C7C7C7',
                                    borderRadius: '5px',
                                    padding: '10px',
                                    height: '300px',
                                    "@media (max-width: 1000px)": {
                                        height: '200px',
                                    }
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: 'auto',
                                        height: '100%'
                                    }}>
                                        <input
                                            type="file"
                                            ref={imgRef}
                                            style={{ display: "none" }}
                                            accept=".jpg,.jpeg,.png"
                                            onChange={(e) => {
                                                handleFileChange(e)
                                            }}
                                        />
                                        <img className={styles.illustration} src={data['image']} />
                                        {data['image'] ?
                                            // <Box sx={{
                                            //     display: 'flex',
                                            //     "@media (max-width: 500px)": {
                                            //         justifyContent: 'end'
                                            //     }
                                            // }} >
                                            //     <img
                                            //         src={icon_delete}
                                            //         style={{ position: 'absolute', cursor: 'pointer' }}
                                            //         onClick={() => { setData({ ...data, 'image': null }) }}
                                            //     />
                                            // </Box>
                                            <Box>
                                                <img
                                                    src={icon_delete}
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => { setData({ ...data, 'image': null }) }}
                                                />
                                            </Box>
                                            : null
                                        }
                                    </Box>
                                </Box>
                            </Box>
                            <Box>
                                <Box sx={{ fontWeight: 500 }}>คำอธิบายหลักสูตร</Box>
                                <TextField
                                    size='small'
                                    fullWidth
                                    multiline
                                    rows={4}
                                    placeholder='คำอธิบายหลักสูตร'
                                    name='detail'
                                    value={data['detail']}
                                    onChange={handleChange}
                                />
                            </Box>
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 500px)": {
                                    gridTemplateColumns: '1fr',
                                }
                            }}>
                                <Box>
                                    <Box>คำสำคัญ / แท็ก</Box>
                                    <TextField
                                        size='small'
                                        fullWidth
                                        placeholder='คำสำคัญ / แท็ก'
                                        name='keyword'
                                        value={data['keyword']}
                                        onChange={handleChange}
                                    />
                                </Box>
                                <Box>
                                    <Box>จำนวนชั่วโมงเรียน (ชั่วโมง.นาที)</Box>
                                    <TextField
                                        type='number'
                                        size='small'
                                        fullWidth
                                        placeholder='จำนวนชั่วโมงเรียน'
                                        name='hour'
                                        value={data['hour']}
                                        onChange={handleChange}
                                    />
                                </Box>
                            </Box>
                            <Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '5px', fontWeight: 500 }}>รายละเอียดหลักสูตร <img style={{ width: '25px', cursor: 'pointer' }} src={add} onClick={() => { addValueCourse() }} /></Box>
                                <Box sx={{ display: 'grid', gridGap: '10px' }}>
                                    {course.map((item, index) => (
                                        <Box sx={{
                                            border: '1px solid #C7C7C7',
                                            borderRadius: '5px',
                                            display: 'grid',
                                            gridGap: '10px',
                                            padding: '20px'
                                        }} key={index}>
                                            <Box>บทที่ {index + 1}</Box>
                                            <TextField
                                                size='small'
                                                fullWidth
                                                placeholder='บทเรียนเริ่มต้น'
                                                value={item['title']}
                                                onChange={(event) => { handleChangeCourse(event, index) }}
                                            />
                                            <FormControl>
                                                <RadioGroup
                                                    row
                                                    defaultValue={'link'}
                                                    value={choice['type']}
                                                    onChange={(e) => { handleChangeRadio(e, index) }}
                                                >
                                                    <FormControlLabel value='link' control={<Radio />} label="แนบลิ้งค์วิดีโอบทเรียน" />
                                                    <FormControlLabel value='file' control={<Radio />} label="แนบไฟล์วิดีโอบทเรียน" />
                                                </RadioGroup>
                                            </FormControl>

                                            {choice[index]?.['type'] === 'link' ?
                                                <TextField
                                                    size='small'
                                                    fullWidth
                                                    placeholder='แนบลิ้งค์'
                                                    value={item['attactment_files'][1]['url']}
                                                    onChange={(event) => { handleChangeCourseVideo(event, index) }}
                                                />
                                                :
                                                <>
                                                    <Typography className={styles.custom_file_upload} id='file-upload' onClick={handleButtonClickVideo}>{item['attactment_files'][1]['url'] ? item['attactment_files'][1]['url'] : 'แนบไฟล์'}</Typography>
                                                    <input
                                                        id='file-upload'
                                                        type="file"
                                                        ref={linkRef}
                                                        accept="video/*"
                                                        onChange={(event) => {
                                                            handleFileChangeVideo(event, index)
                                                        }}
                                                    />
                                                </>
                                            }

                                            <Box>เอกสารประกอบการเรียน (ถ้ามี)</Box>
                                            <Box>
                                                <Typography
                                                    className={styles.custom_file_upload}
                                                    id='file-upload'
                                                    onClick={() => handleButtonClickDoc(index)}
                                                >
                                                    {item['attactment_files'][0]['url'] ? item['attactment_files'][0]['url'] : 'แนบไฟล์'}
                                                </Typography>
                                                <input
                                                    id='file-upload'
                                                    type="file"
                                                    accept=".pdf,.docx,.xlsx,.ppt,.pptx,.jpeg,.jpg,.png,.txt"
                                                    ref={el => fileRef.current[index] = el}
                                                    onChange={(event) => {
                                                        handleFileChangeDoc(event, index)
                                                    }}
                                                />
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                                <img src={icon_delete} onClick={() => { removeValueCourse(index) }} />
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <Button variant='contained' onClick={() => {
                                if (!data['name']) {
                                    return alert('กรุณากรอกชื่อหลักสูตร')
                                }
                                if (data['image'] === null) {
                                    return alert('กรุณาเลือกรูปภาพประกอบ')
                                }
                                if (!data['detail']) {
                                    return alert('กรุณากรอกคำอธิบายหลักสูตร')
                                }
                                if (!data['keyword']) {
                                    return alert('กรุณากรอกคำสำคัญ / แท็ก')
                                }
                                if (!data['hour']) {
                                    return alert('กรุณากรอกจำนวนชั่วโมงเรียน')
                                }
                                handleButton('2')
                            }}>ถัดไป</Button>
                        </Box>
                    </>
                ) : null}

                {location.state.button === "2" ? (
                    <>
                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            padding: '20px',
                            display: 'grid',
                            gridGap: '10px'
                        }}>
                            <Box>
                                <Box sx={{ fontWeight: 500 }}>แบบประเมินก่อนและท้ายบทเรียน</Box>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        name='form_type'
                                        value={data['form_type']}
                                        onChange={handleChange}
                                    >
                                        <FormControlLabel value='มีแบบประเมินทั้งก่อนและท้ายบทเรียน' control={<Radio />} label="มีแบบประเมินทั้งก่อนและท้ายบทเรียน" />
                                        <FormControlLabel value='มีแบบประเมินท้ายบทเรียนอย่างเดียว' control={<Radio />} label="มีแบบประเมินท้ายบทเรียนอย่างเดียว" />
                                        <FormControlLabel value='มีแบบประเมินก่อนบทเรียนอย่างเดียว' control={<Radio />} label="มีแบบประเมินก่อนบทเรียนอย่างเดียว" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>

                            {data['form_type'] === 'มีแบบประเมินทั้งก่อนและท้ายบทเรียน' ?
                                <Box sx={{ display: 'grid', gridGap: '10px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '5px', fontWeight: 500 }}>เพิ่มหัวข้อแบบทดสอบก่อนเรียน <img style={{ width: '25px', cursor: 'pointer' }} src={add} onClick={() => { addValueQuizPre() }} /></Box>
                                    <Box sx={{ display: 'grid', gridGap: '10px' }}>
                                        {quizPre.map((item, index) => (
                                            <Box sx={{
                                                border: '1px solid #C7C7C7',
                                                borderRadius: '5px',
                                                display: 'grid',
                                                gridGap: '10px',
                                                padding: '20px'
                                            }} key={index}>
                                                <Box sx={{
                                                    display: 'grid',
                                                    gridTemplateColumns: '1fr 11fr',
                                                    alignItems: 'center',
                                                    "@media (max-width: 800px)": {
                                                        gridTemplateColumns: '2fr 10fr',
                                                    }
                                                }}>
                                                    <Box>ข้อที่ {index + 1}</Box>
                                                    <TextField
                                                        size='small'
                                                        fullWidth
                                                        placeholder='พิมพ์คำถามที่นี่'
                                                        value={item['question_name']}
                                                        onChange={(e) => { handleChangeNameQuiz(e, index) }}
                                                    />
                                                </Box>

                                                {item['question_answer'].map((i, idx) => (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '10px' }} key={idx} >
                                                        <FormGroup
                                                            value={i['value']}
                                                            onChange={(e) => { handleChangeValueChoicePre(e, index, idx) }}
                                                        >
                                                            <FormControlLabel value='1' control={<Checkbox checked={i['value'] === '1'} />} />
                                                        </FormGroup>
                                                        <TextField
                                                            size='small'
                                                            fullWidth
                                                            variant="standard"
                                                            placeholder='กดเพื่อเพิ่มตัวเลือก'
                                                            value={i['name']}
                                                            onChange={(e) => { handleChangeNameChoice(e, index, idx) }}
                                                            onKeyDown={(ev) => {
                                                                if (ev.key === 'Enter') {
                                                                    addChoicePre(index)
                                                                }
                                                            }}
                                                        />

                                                        <CloseIcon style={{ cursor: 'pointer' }} onClick={() => { removeChoicePre(index, idx) }} />
                                                    </Box>
                                                ))}

                                                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                                    <img src={icon_delete} onClick={() => { removeValueQuizPre(index) }} />
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>

                                    <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '5px', fontWeight: 500 }}>เพิ่มหัวข้อแบบทดสอบหลังเรียน <img style={{ width: '25px', cursor: 'pointer' }} src={add} onClick={() => { addValueQuizPost() }} /></Box>
                                    <Box sx={{ display: 'grid', gridGap: '10px' }}>
                                        {quizPost.map((item, index) => (
                                            <Box sx={{
                                                border: '1px solid #C7C7C7',
                                                borderRadius: '5px',
                                                display: 'grid',
                                                gridGap: '10px',
                                                padding: '20px'
                                            }} key={index}>
                                                <Box sx={{
                                                    display: 'grid',
                                                    gridTemplateColumns: '1fr 11fr',
                                                    alignItems: 'center',
                                                    "@media (max-width: 800px)": {
                                                        gridTemplateColumns: '2fr 10fr',
                                                    }
                                                }}>
                                                    <Box>ข้อที่ {index + 1}</Box>
                                                    <TextField
                                                        size='small'
                                                        fullWidth
                                                        placeholder='พิมพ์คำถามที่นี่'
                                                        value={item['question_name']}
                                                        onChange={(e) => { handleChangeNameQuizPost(e, index) }}
                                                    />
                                                </Box>

                                                {item['question_answer'].map((i, idx) => (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '10px' }} key={idx} >
                                                        <FormGroup
                                                            value={i['value']}
                                                            onChange={(e) => { handleChangeValueChoicePost(e, index, idx) }}
                                                        >
                                                            <FormControlLabel value='1' control={<Checkbox checked={i['value'] === '1'} />} />
                                                        </FormGroup>
                                                        <TextField
                                                            size='small'
                                                            fullWidth
                                                            variant="standard"
                                                            placeholder='กดเพื่อเพิ่มตัวเลือก'
                                                            value={i['name']}
                                                            onChange={(e) => { handleChangeNameChoicePost(e, index, idx) }}
                                                            onKeyDown={(ev) => {
                                                                if (ev.key === 'Enter') {
                                                                    addChoicePost(index)
                                                                }
                                                            }}
                                                        />

                                                        <CloseIcon style={{ cursor: 'pointer' }} onClick={() => { removeChoicePost(index, idx) }} />
                                                    </Box>
                                                ))}

                                                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                                    <img src={icon_delete} onClick={() => { removeValueQuizPost(index) }} />
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                                : data['form_type'] === 'มีแบบประเมินท้ายบทเรียนอย่างเดียว' ?
                                    <Box sx={{ display: 'grid', gridGap: '10px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '5px', fontWeight: 500 }}>เพิ่มหัวข้อแบบทดสอบหลังเรียน <img style={{ width: '25px', cursor: 'pointer' }} src={add} onClick={() => { addValueQuizPost() }} /></Box>
                                        <Box sx={{ display: 'grid', gridGap: '10px' }}>
                                            {quizPost.map((item, index) => (
                                                <Box sx={{
                                                    border: '1px solid #C7C7C7',
                                                    borderRadius: '5px',
                                                    display: 'grid',
                                                    gridGap: '10px',
                                                    padding: '20px'
                                                }} key={index}>
                                                    <Box sx={{
                                                        display: 'grid',
                                                        gridTemplateColumns: '1fr 11fr',
                                                        alignItems: 'center',
                                                        "@media (max-width: 800px)": {
                                                            gridTemplateColumns: '2fr 10fr',
                                                        }
                                                    }}>
                                                        <Box>ข้อที่ {index + 1}</Box>
                                                        <TextField
                                                            size='small'
                                                            fullWidth
                                                            placeholder='พิมพ์คำถามที่นี่'
                                                            value={item['question_name']}
                                                            onChange={(e) => { handleChangeNameQuizPost(e, index) }}
                                                        />
                                                    </Box>

                                                    {item['question_answer'].map((i, idx) => (
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '10px' }} key={idx} >
                                                            <FormGroup
                                                                value={i['value']}
                                                                onChange={(e) => { handleChangeValueChoicePost(e, index, idx) }}
                                                            >
                                                                <FormControlLabel value='1' control={<Checkbox checked={i['value'] === '1'} />} />
                                                            </FormGroup>
                                                            <TextField
                                                                size='small'
                                                                fullWidth
                                                                variant="standard"
                                                                placeholder='กดเพื่อเพิ่มตัวเลือก'
                                                                value={i['name']}
                                                                onChange={(e) => { handleChangeNameChoicePost(e, index, idx) }}
                                                                onKeyDown={(ev) => {
                                                                    if (ev.key === 'Enter') {
                                                                        addChoicePost(index)
                                                                    }
                                                                }}
                                                            />

                                                            <CloseIcon style={{ cursor: 'pointer' }} onClick={() => { removeChoicePost(index, idx) }} />
                                                        </Box>
                                                    ))}

                                                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                                        <img src={icon_delete} onClick={() => { removeValueQuizPost(index) }} />
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                    :
                                    <Box sx={{ display: 'grid', gridGap: '10px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '5px', fontWeight: 500 }}>เพิ่มหัวข้อแบบทดสอบก่อนเรียน <img style={{ width: '25px', cursor: 'pointer' }} src={add} onClick={() => { addValueQuizPre() }} /></Box>
                                        <Box sx={{ display: 'grid', gridGap: '10px' }}>
                                            {quizPre.map((item, index) => (
                                                <Box sx={{
                                                    border: '1px solid #C7C7C7',
                                                    borderRadius: '5px',
                                                    display: 'grid',
                                                    gridGap: '10px',
                                                    padding: '20px'
                                                }} key={index}>
                                                    <Box sx={{
                                                        display: 'grid',
                                                        gridTemplateColumns: '1fr 11fr',
                                                        alignItems: 'center',
                                                        "@media (max-width: 800px)": {
                                                            gridTemplateColumns: '2fr 10fr',
                                                        }
                                                    }}>
                                                        <Box>ข้อที่ {index + 1}</Box>
                                                        <TextField
                                                            size='small'
                                                            fullWidth
                                                            placeholder='พิมพ์คำถามที่นี่'
                                                            value={item['question_name']}
                                                            onChange={(e) => { handleChangeNameQuiz(e, index) }}
                                                        />
                                                    </Box>

                                                    {item['question_answer'].map((i, idx) => (
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '10px' }} key={idx} >
                                                            <FormGroup
                                                                value={i['value']}
                                                                onChange={(e) => { handleChangeValueChoicePre(e, index, idx) }}
                                                            >
                                                                <FormControlLabel value='1' control={<Checkbox checked={i['value'] === '1'} />} />
                                                            </FormGroup>
                                                            <TextField
                                                                size='small'
                                                                fullWidth
                                                                variant="standard"
                                                                placeholder='กดเพื่อเพิ่มตัวเลือก'
                                                                value={i['name']}
                                                                onChange={(e) => { handleChangeNameChoice(e, index, idx) }}
                                                                onKeyDown={(ev) => {
                                                                    if (ev.key === 'Enter') {
                                                                        addChoicePre(index)
                                                                    }
                                                                }}
                                                            />

                                                            <CloseIcon style={{ cursor: 'pointer' }} onClick={() => { removeChoicePre(index, idx) }} />
                                                        </Box>
                                                    ))}

                                                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                                        <img src={icon_delete} onClick={() => { removeValueQuizPre(index) }} />
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                            }
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'end', gridGap: '10px' }}>
                            <Button variant='outlined' onClick={() => { handleButton('1') }}>ย้อนกลับ</Button>
                            <Button variant='contained' onClick={() => {
                                // console.log(quizPost)
                                clickSaveNewCourse()
                            }}>บันทึกข้อมูล</Button>
                        </Box>
                    </>
                ) : null}

            </Box>
        </>
    )
}

export default EditCourse
